module.exports = __webpack_public_path__ + "assets/img/Large_1.0b74be29.svg";